import { ActionConfig, useAction } from './action';
import css from './useActionLoadingIndicator.module.less';
import { useTranslator } from '@/translations/translator';
import LoadingIndicator from '@whiz-cart/ui-shared/loading/loadingIndicator.tsx';

export function useActionLoadingIndicator(
    display: ActionConfig<any>['display'],
    config?: Omit<ActionConfig<any>, 'action' | 'display' | 'label' | 'icon' | 'id'> | undefined,
) {
    const t = useTranslator();
    useAction({ id: 'loading', isLoading: true, display, label: t('loading'), icon: <ActionLoadingIcon />, ...config }, '', [display]);
}

export function ActionLoadingIcon() {
    return <LoadingIndicator className={css.loading} size="1rem" thickness={6} noMargin center={false} />;
}
